import { render, staticRenderFns } from "./ContactRequestAssignMember.vue?vue&type=template&id=77a0a3d0"
import script from "./ContactRequestAssignMember.vue?vue&type=script&lang=js"
export * from "./ContactRequestAssignMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports